module.exports = __webpack_public_path__ + "pin_lightblue.36c74a.png";